import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService, User } from '../services/auth.service';

const ROLE_ROUTES: Record<User['role'], string[]> = {
  admin: ['/dashboard', '/floor-plan', '/menu', '/orders', '/kitchen', '/billing', '/reports', '/insumos', '/configuracion'],
  mesero: ['/dashboard', '/floor-plan', '/menu', '/orders'],
  cocinero: ['/dashboard', '/kitchen'],
  cajero: ['/dashboard', '/billing', '/reports', '/insumos'],
};

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const user = this.authService.getCurrentUser();
    if (!user) {
      this.router.navigate(['/login']);
      return false;
    }
    const allowed = ROLE_ROUTES[user.role];
    const url = state.url.split('?')[0];
    const canAccess = allowed?.some(path => url === path || url.startsWith(path + '/')) ?? false;
    if (!canAccess) {
      this.router.navigate(['/dashboard']);
      return false;
    }
    return true;
  }
}
